import { useMemo } from "react";
import ReactMarkdown from "react-markdown";

export type AiContentRenderModel = {
  kind: "ai_content";
  contentType: "markdown" | "svg" | "html";
  content: string;
  title?: string;
  byteSize: number;
  sources?: Array<{ url: string; title: string }>;
};

function sanitizeSvgMarkup(svg: string): string {
  let out = svg.replace(/<script\b[\s\S]*?>[\s\S]*?<\/script>/gi, "");
  out = out.replace(/\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  return out;
}

export function AiContentRenderer(props: { model: AiContentRenderModel }) {
  const { model } = props;

  const safeSvg = useMemo(
    () => (model.contentType === "svg" ? sanitizeSvgMarkup(model.content) : ""),
    [model.content, model.contentType]
  );

  if (model.contentType === "markdown") {
    return (
      <div className="aiContentMarkdown proseCompact">
        <ReactMarkdown>{model.content}</ReactMarkdown>
      </div>
    );
  }

  if (model.contentType === "svg") {
    return <div className="aiContentSvgHost" dangerouslySetInnerHTML={{ __html: safeSvg }} />;
  }

  const srcDoc = useMemo(
    () =>
      `<!DOCTYPE html><html><head><meta charset="utf-8"><style>body{margin:0;font-family:system-ui,sans-serif;padding:8px;font-size:14px;line-height:1.45;}</style></head><body>${model.content}</body></html>`,
    [model.content]
  );

  return (
    <div className="aiContentHtmlFrameWrap">
      <iframe
        className="aiContentHtmlFrame"
        title={model.title ?? "AI content"}
        sandbox="allow-same-origin"
        srcDoc={srcDoc}
      />
    </div>
  );
}
